import { useState, useEffect } from 'react';
import { Direction } from '../types';
import { tripsApi, directionToApi } from '../lib/api';
import { logger } from '../lib/logger';

interface UseTripCountProps {
  tripDate: string;
  routeId?: string;
  direction?: Direction;
  enabled?: boolean;
}

/**
 * Hook para obtener el conteo de viajes registrados - usa API FastAPI
 */
export const useTripCount = ({ tripDate, routeId, direction, enabled = true }: UseTripCountProps) => {
  const [tripCount, setTripCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    const fetchTripCount = async () => {
      setLoading(true);
      try {
        if (!routeId || !direction || !tripDate) {
          setTripCount(null);
          setLoading(false);
          return;
        }

        const result = await tripsApi.count(
          routeId,
          directionToApi(direction),
          tripDate
        );

        setTripCount(result.count);
      } catch (error) {
        logger.error('Error fetching trip count', error instanceof Error ? error : new Error(String(error)), {
          tripDate, routeId, direction: direction ? directionToApi(direction) : undefined,
        });
        setTripCount(null);
      } finally {
        setLoading(false);
      }
    };

    if (tripDate) {
      fetchTripCount();
    }
  }, [enabled, tripDate, routeId, direction]);

  return { tripCount, loading };
};
